var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v2026-overlay-card",attrs:{"id":_vm.id,"data-render-key":_vm.renderKey}},[_vm._t("default",null,{"dirty":_vm.renderKey})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }